import React, { useState } from "react";
import Image from "../components/image.js";
import styled from "styled-components";
import Container from "../components/container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faShare } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/global-context-provider";
import { Link, useStaticQuery, graphql } from "gatsby";
import { _ } from "../utils/i18n";
import Paragraph from "./paragraph.js";
import { HiddenOnDesktop, HiddenOnPhone } from "./hidden.js";
import vipps from "../images/vipps-logo.svg";
import klarna from "../images/klarna.webp";
import Button from "./button.js";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    flex-direction: column;
  }
`;

const WrapperRight = styled.div`
  display: flex;
  width: 100%;
`;

const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 4px 2px rgb(0 0 0 / 4%);
  width: 100%;
`;

const ProductWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 1.5rem;
  background-color: var(--color-white);
  padding: 2rem;

  &:nth-child(even) {
    background-color: var(--color-body);
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    height: 100%;
    width: 100%;
    padding: 1rem;
  }
`;

const AddOrDeleteProducts = styled.div`
  display: flex;
  flex-flow: column;
`;

const RemoveButton = styled.button`
  background-color: transparent;
  font-size: 1rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: 0.8rem;
  }
`;
const RemoveIcon = styled(FontAwesomeIcon)`
  margin-left: 10px;
  font-size: 1rem;
`;
const StyledImage = styled(Image)`
  width: 120px;
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius);
`;

const NameWrapper = styled.div`
  width: 100%;
`;

const AttributeWrapper = styled.div`
  margin-left: 1.5rem;
  p {
    text-align: left;
    margin-bottom: 5px;
    font-size: 0.85rem;
  }
  span {
    font-weight: bold;
  }
`;

const WrapperTotal = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const TotalPrice = styled.p`
  font-size: 14px;
  width: 100%;
  text-align: end;
  margin-top: 2rem;
  font-weight: 600;
`;

const TotalText = styled.p`
  font-size: 14px;
  width: 100%;
  text-align: start;
  margin-top: 2rem;
  font-weight: 600;
`;

const BottomDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 2rem;
  background-color: var(--color-white);
  box-shadow: 0 0 4px 2px rgb(0 0 0 / 4%);
  margin: 0 2.5rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: 100%;
    margin: 2rem 0;
    padding: 1rem;
  }
`;

const BackToShopBtn = styled(Link)`
  text-decoration: none;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 8px 15px;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.primary};
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.primary};
  }
`;

const StyledLink = styled(Link)`
  width: 100%;
  font-weight: 600;
  font-size: 1.1rem;
  display: block;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
const MiddleWrapper = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  justify-content: space-between;
  flex-basis: 75%;
  align-items: flex-start;
`;
const QuantityBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem;
  margin-top: 0.5rem;
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius);
  background-color: var(--color-white);
  gap: 0.5rem;
`;

const ChangeQtyBtn = styled(FontAwesomeIcon)`
  cursor: pointer;
  color: ${({ productQty }) => (productQty === 1 ? "grey" : "black")};
`;

const CheckoutBtn = styled(Link)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  padding: 8px 15px;
  font-size: 15px;
  transition: all 0.3s ease-in-out;
  width: 100%;
  text-align: center;
  border-radius: var(--border-radius);
  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    border: 1px solid ${({ theme }) => theme.colors.primary};
  }
`;

const RightWrapper = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  justify-content: space-between;
`;
const Price = styled.div`
  display: grid;
  padding-block-end: 0.525rem;
  & p {
    margin: 0;
    text-align: right;
  }
`;

const PaymentImage = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 0.5rem;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 1.5rem;
  background-color: var(--color-white);
  padding: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    height: 100%;
    width: 100%;
    padding: 1rem;
  }
`;
const ButtonTitle = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 2rem;
`;

const LoadingIcon = styled(FontAwesomeIcon)`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.black};
  opacity: 0.5;
`;

const Cart = () => {
  const { wp, wpProductCategory } = useStaticQuery(graphql`
    query {
      wp {
        wcSettings {
          currency
          checkoutUrl
        }
      }
      wpProductCategory {
        uri
      }
    }
  `);
  const { cart } = React.useContext(GlobalStateContext);
  const dispatch = React.useContext(GlobalDispatchContext);

  function removeProduct(id) {
    dispatch({
      type: "UPDATE_CART",
      value: cart.filter((product) => product.id !== id),
    });
  }

  function increaseQty(product) {
    dispatch({ type: "INCREASE_QUANTITY_IN_CART", value: product });
  }

  function decreaseQty(product) {
    dispatch({ type: "REMOVE_FROM_CART", value: product });
  }

  let total = 0;

  cart.forEach((item) => {
    total += item.priceRaw * item.quantity;
  });

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleButtonClick = () => {
    togglePopup(); // Call togglePopup
  };

  const quantity = (product) => (
    <QuantityBox>
      <ChangeQtyBtn
        icon={faMinus}
        size="xs"
        onClick={() => decreaseQty(product)}
        $productQty={product.quantity}
      />
      <Paragraph
        fontSize="clamp(0.8rem, 2vw, 1rem)"
        content={product.quantity}
        align="center"
        innerStyle={{
          width: "clamp(2rem, 2vw, 3.525rem)",
          margin: 0,
        }}
      />
      <ChangeQtyBtn
        icon={faPlus}
        size="xs"
        onClick={() => increaseQty(product)}
        $productQty={product.quantity}
      />
    </QuantityBox>
  );

  return (
    <Container maxWidth="md">
      <p style={{ fontSize: "30px" }}> {_("Din handlekurv")}</p>
      {cart && cart.length > 0 ? (
        <>
          <Wrapper>
            <WrapperContent>
              {cart.map((product) => (
                <ProductWrapper key={product.id}>
                  <AddOrDeleteProducts>
                    <StyledImage image={product.image} />
                    {quantity(product)}
                    <HiddenOnDesktop>{quantity}</HiddenOnDesktop>
                  </AddOrDeleteProducts>
                  <MiddleWrapper>
                    <NameWrapper>
                      <StyledLink to={product.uri}>{product.name}</StyledLink>
                      {product.sku && (
                        <Paragraph content={product?.sku} fontSize="0.8rem" />
                      )}
                      <AttributeWrapper>
                        {product.attributeLabels?.map((attribute) => (
                          <p key={attribute.id}>
                            <span>{attribute.label}:</span> {attribute.value}
                          </p>
                        ))}
                      </AttributeWrapper>
                    </NameWrapper>
                    <HiddenOnPhone>{quantity}</HiddenOnPhone>
                  </MiddleWrapper>
                  <RightWrapper>
                    <Price>
                      {product.salePrice ? (
                        <>
                          <Paragraph
                            color="var(--color-accent1)"
                            content={product.salePrice}
                            fontSize="clamp(0.9rem, 2vw, 1rem)"
                            innerStyle={{ fontWeight: "600" }}
                          />
                          <Paragraph
                            content={product.regularPrice}
                            innerStyle={{ textDecoration: "line-through" }}
                            fontSize="clamp(0.8rem, 2vw, 1rem)"
                          />
                        </>
                      ) : (
                        <Paragraph
                          content={product.price}
                          fontSize="clamp(0.9rem, 2vw, 1rem)"
                          innerStyle={{ fontWeight: "600" }}
                        />
                      )}
                    </Price>
                    <RemoveButton onClick={() => removeProduct(product.id)}>
                      {_("Ta vekk")} <RemoveIcon icon={faTrashCan} />
                    </RemoveButton>
                  </RightWrapper>
                </ProductWrapper>
              ))}
              <ButtonWrapper>
                <div className="button-container">
                  <Button
                    onClick={handleButtonClick}
                    variant="outlined"
                    style={{
                      width: "100%",
                    }}
                  >
                    <ButtonTitle>
                      <span>{_("Del handlekurven din")}</span>
                      <span>
                        <LoadingIcon
                          icon={faShare}
                          className="fa-share"
                        ></LoadingIcon>
                      </span>
                    </ButtonTitle>
                  </Button>
                </div>
              </ButtonWrapper>
            </WrapperContent>
            <WrapperRight>
              <BottomDiv>
                <p>Oversikt</p>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "end",
                  }}
                >
                  <BackToShopBtn to={wpProductCategory.uri}>
                    {_("Tilbake til butikken")}
                  </BackToShopBtn>
                </div>

                <WrapperTotal>
                  <TotalText>{_("Total:")} </TotalText>
                  <TotalPrice>
                    {new Intl.NumberFormat("nb-NO", {
                      style: "currency",
                      currency: wp.wcSettings.currency,
                    }).format(total)}{" "}
                  </TotalPrice>
                </WrapperTotal>
                <TotalText>{_("Vi aksepterer:")}</TotalText>
                <PaymentImage>
                  <Image src={vipps} alt="Vipps" />
                  <Image src={klarna} alt="Klarna" />
                </PaymentImage>
                <div
                  style={{
                    marginTop: "1rem",
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <CheckoutBtn to={wp.wcSettings.checkoutUrl}>
                    {_("Til checkout")}
                  </CheckoutBtn>
                </div>
              </BottomDiv>
            </WrapperRight>
          </Wrapper>
        </>
      ) : (
        <p>
          {_("Handlekurven din er tom")}{" "}
          <Link to={wpProductCategory.uri}>{_("Tilbake til butikken")}</Link>
        </p>
      )}
    </Container>
  );
};

export default Cart;
